<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import FileBoxVertical from '../common/FileBoxVertical.vue'
import CheckMoreText from '../common/CheckMoreText.vue'

import { getPageThemeColor, getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp25',
  components: { ModuleTitle, FileBoxVertical, CheckMoreText },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getPageThemeColor, getShadowColor,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    }
  }
}
</script>

<template>
  <div class="modules-id-25">
    <module-title :title="moduleOption.title" margin-bottom="40" />
    <div class="comp-transverse-2 modules-id-25-content pointer">
      <div
        v-for="(v, i) in moduleOption.list.slice(0, 3)"
        :key="`modules-25-${i}`"
        @click="onModuleItem(v)"
      >
        <file-box-vertical
          v-if="i === 0"
          :headline="v.list[0] && v.list[0].headline"
          :filename="v.list[0] && v.list[0].typename"
        />
        <div
          v-else
          class="item"
          :style="{boxShadow: `0 4px 15px 0 ${getShadowColor(path)}`}"
        >
          <p class="item-title h-line-2">{{ v.subtitle || '' }}</p>
          <div v-if="v.list && v.list.length > 0" class="item-img-group">
            <el-image
              v-for="(item, idx) in v.list"
              :key="`${item.photo}-${idx}`"
              :src="item.photo | imgPath"
              alt="photo"
              fit="cover"
              class="group-img"
            />
          </div>
          <p v-else>暂无</p>
          <check-more-text class="check-more-text-25" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-25-content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 717px;
  column-gap: 20px;
}
.item {
  width: 240px;
  height: 263px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .item-title {
    width: 190px;
    height: 66px;
    font-size: 17px;
    font-weight: 800;
    color: #000;
    text-align: center;
    line-height: 25px;
    margin-top: 20px;
  }
  .item-img-group {
    width: 220px;
    display: flex;
    justify-content: space-between;
    .group-img {
      width: 107px;
      height: 94px;
      border-radius: 5px;
    }
  }
  .check-more-text-25 {
    margin-top: 30px;
  }
}
</style>
